module.exports = __webpack_public_path__ + "img/10.2fdbbd86.jpg";